export default __webpack_public_path__ + "static/media/WordWork_00.c083e166.png";